export const TRAJECTORY_YEARS = [-15, 0, 1, 3, 5, 10, 15, 20, 30, 45]

const MIN_PORTFOLIO_VALUE = 1

export function parsePortfolioAmount(value: string, initialValue = "100000"): number {
  const raw = value.length > 0 ? value : initialValue
  const parsed = parseFloat(raw.replace(/[^0-9.-]/g, ""))

  if (!Number.isFinite(parsed)) {
    return MIN_PORTFOLIO_VALUE
  }

  return Math.max(MIN_PORTFOLIO_VALUE, parsed)
}

export function parseRate(value: string, initialValue: string): number {
  const raw = value.length > 0 ? value : initialValue
  const parsed = parseFloat(raw.replace(/[^0-9.-]/g, ""))

  return Number.isFinite(parsed) ? parsed / 100 : 0
}

export function projectedValue(portfolioValue: number, growthRate: number, aumFee: number, year: number): number {
  if (year <= 0) {
    return portfolioValue
  }

  const monthlyGrowth = Math.pow(1 + growthRate, 1 / 12)
  const monthlyFeeFactor = 1 - aumFee / 12
  const months = year * 12

  return portfolioValue * Math.pow(monthlyGrowth * monthlyFeeFactor, months)
}

export function trajectory(portfolioValue: number, growthRate: number, aumFee: number): { x: number; y: number }[] {
  return TRAJECTORY_YEARS.map((year) => ({
    x: year,
    y: projectedValue(portfolioValue, growthRate, aumFee, year),
  }))
}

export function trajectoryValueAt(series: { x: number; y: number }[], year: number): number {
  const point = series.find((p) => p.x === year) ?? series.find((p) => p.x === 0)

  return point?.y ?? 0
}
